export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8586.00f5d2f5.jpg";